import { MCApprovalTypeId, MCApprovalTypeData } from "@maslul/common-services";

export abstract class ApprovalTypeData extends MCApprovalTypeData {

    public static isPackageYoursFieldDisplay = [
        MCApprovalTypeId.PersonalImport,
        MCApprovalTypeId.STANDARDS_EXEMPT_PI
    ];

    public static approvalOfManufacturerNameList = [
        MCApprovalTypeData.communicationApprovals,
    ];
}